import Vue from 'vue';
import VueRouter from 'vue-router'
import Login from '@/views/Login'
import Dashboard from '@/views/Dashboard'
import Activity from '@/views/Activity'
import Conversations from '@/views/Conversations'
import Connections from '@/views/Connections'
import Credentials from '@/views/Credentials'
import Conversation from '@/components/Conversation'
import ConnectionDetails from '@/components/ConnectionDetails'

import store from '@/store/index'

Vue.use(VueRouter);

const checkAuthLogin = (to, from, next) => {
  const { user, walletOpen } = store.getters['hearro/loggedInUser']
  return !walletOpen ? next() : next({ path: `/user/${user.id}` })
}

const checkAuth = (to, from, next) => {
  return !store.getters['hearro/loggedInUser'].walletOpen ? next({ path: '/' }) : next()
}

const routes = [
  {
    beforeEnter: checkAuthLogin,
    path: '/',
    name: 'login',
    component: Login
  },
  {
    beforeEnter: checkAuth,
    path: '/user/:id',
    name: 'dashboard',
    component: Dashboard,
    children: [
      {
        path: 'activity',
        name: 'activity',
        component: Activity
      },
      {
        path: 'conversations',
        name: 'conversations',
        component: Conversations,
        children: [
          {
            path: ':cid',
            name: 'conversation',
            component: Conversation,
            props: true
          }
        ]
      },
      {
        path: 'connections',
        name: 'connections',
        component: Connections,
        children: [
          {
            path: ':conid',
            name: 'connectionDetails',
            component: ConnectionDetails,
            props: true
          }
        ]
      },
      {
        path: 'credentials',
        name: 'credentials',
        component: Credentials
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
